module.exports = __webpack_public_path__ + "media/images/tables-c484621c00fe6a82dc2f8be94dfd64c6.svg";